import "./Investments.css";
import Hero from "../../components/Hero/Hero";
import Heading from "../../components/Heading/Heading";
import SubHeading from "../../components/SubHeading/SubHeading";
import ImagesList from "../../components/ImagesList/ImagesList";
import H1 from "../../components/H1/H1";
import usePageTitle from "../../hooks/usePageTitle";

const Investments = () => {
    usePageTitle("Investments");

    const images = [
        {
            title: "Principal investments",
            image: "/images/waves/investments1.jpg",
            content:
                "Selective principal positions where we can influence outcomes. We provide seed equity, craft a clear value plan, and set cadence and reporting so progress is visible. We can also engage directly with operating support.",
        },
        {
            title: "Co-investments",
            image: "/images/waves/investments2.jpg",
            content:
                "On select deals we invest alongside trusted partners. We move quickly on diligence, align terms, and favour situations where we or our partners bring an operating edge.",
        },
        {
            title: "Australian emerging fund managers",
            image: "/images/waves/investments3.jpg",
            content:
                "We back niche Australian emerging fund managers – holding equity, seeding strategies, and delivering institutional fund services under our AFSL, from compliance to investor reporting. This enables managers to focus on investment excellence.",
        },
        {
            title: "Strategic focus",
            image: "/images/waves/investments4.jpg",
            content:
                "We concentrate on high-conviction alternatives uncorrelated with traditional assets – bringing diversification, clear value-added levers, and flexible capital to navigate complexity and generate strong cash flow with measurable impact.",
        },
        {
            title: "International reach",
            image: "/images/waves/investments5.jpg",
            content:
                "Our network spans the UK, Europe, the US, Australia, and Africa, giving us access to opportunities, partners, and ideas beyond domestic markets — broadening perspective and strengthening diversification.",
        },
        {
            title: "Investment themes",
            image: "/images/waves/investments6.jpg",
            content:
                "Our investment themes focus on technology, finance, health & wellbeing, and access to justice, driving innovation, supporting healthier lives, and creating fairer systems.",
        },
    ];

    return (
        <div className="page-content investments-page">
            <Hero name="investments">
                <H1>Investments</H1>
            </Hero>

            <section className="padded">
                <div className="container">
                    <Heading>
                        We invest in a handful of high-conviction opportunities. We prize simple
                        models, aligned partners, and patient holds, seeking uncorrelated outcomes
                        and strong cash flow.
                    </Heading>

                    <SubHeading>
                        "Every decision, from portfolio design to partner selection, is intentional.
                        Anchored in the belief that how we invest shapes how we live and the legacy
                        we leave."
                    </SubHeading>

                    <div className="spacer"></div>

                    <ImagesList data={images} />
                </div>
            </section>
        </div>
    );
};

export default Investments;
